import React, { Fragment } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import POSModal from 'PointOfSale/modules/common/component/Modal';
import { ViewTransactionHistoryFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateTimeFormat } from 'Common/GeneralHelper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/';

import { TRANSACTION_HISTORY_TABLE_PAGE_SIZE } from '../../../helpers/Constants';

class ViewHistoryModal extends React.Component {
  state = {
    selectedTransactionId: null,
  };

  isVoidedTransaction = (transaction) => {
    return (
      transaction[Fields.VoidedUser] &&
      transaction[Fields.VoidedUser].length > 0
    );
  };

  isVoidableType = (itemId) => {
    const voidableTransaction = ['PBRK', 'PLUN', 'POTH', 'PSUP', 'PCRE'];

    if (itemId && itemId.length > 0) {
      if (itemId.startsWith('P')) {
        if (voidableTransaction.indexOf(itemId) > -1) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  };

  columns = [
    {
      Header: 'Effective Date',
      accessor: Fields.EffectiveDT,
      filterable: false,
      sortable: false,
      style: { textAlign: 'center' },
      Cell: ({ original }) =>
        defaultDateTimeFormat(moment(original[Fields.EffectiveDT])),
      width: 175,
    },
    {
      Header: 'Item #',
      accessor: Fields.ItemId,
      style: { textAlign: 'center' },
      filterable: false,
      sortable: false,
      width: 65,
    },
    {
      Header: 'Status',
      accessor: Fields.Status,
      style: { textAlign: 'center' },
      width: 50,
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Description',
      accessor: Fields.Description,
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Bal. After',
      accessor: Fields.Balance,
      style: { textAlign: 'right' },
      width: 65,
      Cell: (row) => parseFloat(row.original[Fields.Balance]).toFixed(2),
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Payments',
      accessor: Fields.Payments,
      style: { textAlign: 'right' },
      width: 65,
      Cell: (row) => parseFloat(row.original[Fields.Payments]).toFixed(2),
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Check #',
      accessor: Fields.CheckNumber,
      style: { textAlign: 'right' },
      width: 100,
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Quantity',
      accessor: Fields.Quantity,
      style: { textAlign: 'right' },
      width: 65,
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Purchase',
      accessor: Fields.Purchase,
      width: 65,
      style: { textAlign: 'right' },
      Cell: (row) => parseFloat(row.original[Fields.Purchase]).toFixed(2),
      filterable: false,
      sortable: false,
    },
    {
      Header: '',
      width: 100,
      style: { textAlign: 'center' },
      Cell: ({ original }) => {
        const isVoided = this.isVoidedTransaction(original);
        const isVoidableType = this.isVoidableType(original[Fields.ItemId]);

        const showButton = !(isVoided || !isVoidableType);

        return showButton ? (
          <Button
            active={false}
            toggle={false}
            content={'Void'}
            size={'tiny'}
            onClick={() =>
              this.setState({
                selectedTransactionId: original[Fields.TransactionId],
              })
            }
          />
        ) : null;
      },
    },
  ];

  onFetchTransactionData = (pageNumber) => {
    const { getData } = this.props;

    getData(pageNumber + 1, TRANSACTION_HISTORY_TABLE_PAGE_SIZE, [], []);
  };

  getTable = () => {
    const { data, pages, updatePageNumber, page } = this.props;
    return (
      <ReactTable
        getTrProps={(state, rowInfo) => {
          if (rowInfo && rowInfo.original) {
            const isVoided = this.isVoidedTransaction(rowInfo.original);
            return {
              className: rowInfo.original.isOddRow
                ? 'customRow -oddRow'
                : 'customRow -evenRow',
              style: { color: isVoided ? 'red' : 'inherit' },
            };
          }
          return {};
        }}
        columns={this.columns}
        ref={this.reactTable}
        data={data ? data : []}
        minRows={TRANSACTION_HISTORY_TABLE_PAGE_SIZE}
        pageSize={TRANSACTION_HISTORY_TABLE_PAGE_SIZE}
        showPageJump={false}
        onPageChange={(pageNumber) => {
          updatePageNumber(pageNumber);
          this.onFetchTransactionData(pageNumber);
        }}
        showPageSizeOptions={false}
        defaultFilterMethod={caseInsensitiveFilter}
        loading={this.props.loading}
        pages={pages}
        manual={true}
        page={page}
      />
    );
  };

  render() {
    const {
      updatePageNumber,
      setViewCurrentStudentHistory,
      postVoidTransaction,
      showModal,
      fullName,
    } = this.props;

    return (
      <Fragment>
        <YesNoDialog
          showDialog={this.state.selectedTransactionId != null}
          yesCallback={() => {
            postVoidTransaction(this.state.selectedTransactionId);
            this.setState({ selectedTransactionId: null });
          }}
          noCallback={() => this.setState({ selectedTransactionId: null })}
          title={'Confirm voiding of transaction.'}
          question={'Are you sure you would like to void this transaction?'}
        />
        <POSModal
          header={<div>{`History for ${fullName}`}</div>}
          children={<div>{this.getTable()}</div>}
          open={showModal}
          closeIcon={true}
          onClose={() => {
            setViewCurrentStudentHistory(false);
            updatePageNumber(0);
          }}
          size={'large'}
        />
      </Fragment>
    );
  }
}

ViewHistoryModal.defaultProps = {
  fullName: '',
};

ViewHistoryModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      [Fields.EffectiveDT]: PropTypes.string.isRequired,
      [Fields.ItemId]: PropTypes.string.isRequired,
      [Fields.Status]: PropTypes.string.isRequired,
      [Fields.Description]: PropTypes.string.isRequired,
      [Fields.Balance]: PropTypes.number.isRequired,
      [Fields.Payments]: PropTypes.number.isRequired,
      [Fields.CheckNumber]: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      [Fields.Purchase]: PropTypes.number.isRequired,
    })
  ),
  setViewCurrentStudentHistory: PropTypes.func.isRequired,
  postVoidTransaction: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullName: PropTypes.string.isRequired,
};

export { ViewHistoryModal };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/history/component/ViewHistoryModal.js